import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ModelProvider } from "@/contexts/ModelContext";
import Directory from "@/pages/Directory";
import ToolDetail from "@/pages/ToolDetail";
import AgentsPage from "@/pages/Agents";
import Compare from "@/pages/Compare";
import Algorithm from "@/pages/Algorithm";
import Pricing from "@/pages/Pricing";
import Humanize from "@/pages/Humanize";
import PromptLibrary from "@/pages/PromptLibrary";
import Dashboard from "@/pages/Dashboard";
import SubmitTool from "@/pages/SubmitTool";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Favorites from "@/pages/Favorites";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ChatArena from "@/pages/ChatArena";
import TrendsLibrary from "@/pages/TrendsLibrary";
import Accountant from "@/pages/Accountant";
import LifeHub from "@/pages/LifeHub";
import Quiz from "@/pages/Quiz";
import Methodology from "@/pages/Methodology";
import CreateStudio from "@/pages/Create";
import AskGenius from "@/pages/AskGenius";
import WikifiWorkspace from "@/pages/WikifiWorkspace";
import AdminDiscoveries from "@/pages/AdminDiscoveries";
import AdminDashboard from "@/pages/AdminDashboard";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Profile from "@/pages/Profile";
import { AnalyticsTracker } from "@/components/AnalyticsTracker";
import { Toaster } from "sonner";

function Router() {
  const loc = useLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback/>;
  return (
    <Routes>
      <Route path="/" element={<Directory/>}/>
      <Route path="/create" element={<CreateStudio/>}/>
      <Route path="/ask" element={<AskGenius/>}/>
      <Route path="/wikifi" element={<WikifiWorkspace/>}/>
      <Route path="/workspace" element={<WikifiWorkspace/>}/>
      <Route path="/tool/:slug" element={<ToolDetail/>}/>
      <Route path="/agents" element={<AgentsPage/>}/>
      <Route path="/compare" element={<Compare/>}/>
      <Route path="/algorhytm" element={<Algorithm/>}/>
      <Route path="/algorithm" element={<Algorithm/>}/>
      <Route path="/pricing" element={<Pricing/>}/>
      <Route path="/humanize" element={<Humanize/>}/>
      <Route path="/prompts" element={<PromptLibrary/>}/>
      <Route path="/dashboard" element={<Dashboard/>}/>
      <Route path="/submit" element={<SubmitTool/>}/>
      <Route path="/favorites" element={<Favorites/>}/>
      <Route path="/chat" element={<ChatArena/>}/>
      <Route path="/trends" element={<TrendsLibrary/>}/>
      <Route path="/accountant" element={<Accountant/>}/>
      <Route path="/life" element={<LifeHub/>}/>
      <Route path="/quiz" element={<Quiz/>}/>
      <Route path="/methodology" element={<Methodology/>}/>
      <Route path="/impartiality" element={<Methodology/>}/>
      <Route path="/payment/success" element={<PaymentSuccess/>}/>
      <Route path="/terms" element={<Terms/>}/>
      <Route path="/privacy" element={<Privacy/>}/>
      <Route path="/about" element={<About/>}/>
      <Route path="/contact" element={<Contact/>}/>
      <Route path="/profile" element={<Profile/>}/>
      <Route path="/admin" element={<AdminDashboard/>}/>
      <Route path="/admin/discoveries" element={<AdminDiscoveries/>}/>
      <Route path="/login" element={<Login/>}/>
      <Route path="*" element={<Directory/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <ModelProvider>
            <AnalyticsTracker/>
            <Router/>
            <Toaster position="top-right"/>
          </ModelProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
